<header class="header">
    <div class="header-container">
        <div class="header-logo">
            <a href="/" class="logo-link">
                <img src="./assets/images/header-logo.png" alt="Farco Security" class="logo-image" width="161" height="49">
            </a>
        </div>

        <!-- Desktop Navigation -->
        <div class="header-desktop" *ngIf="!isMobile">
            <a [routerLink]="[isLoggedIn ? '/member/reservations/create' : '/reservation']" routerLinkActive="router-link-active" class="reservation-btn">
                <img src="assets/images/icons/shield_check.png" alt="Shield Icon" class="btn-icon">
                <span class="btn-text">Réservation</span>
            </a>

            <a *ngIf="!isLoggedIn" [routerLink]="['/login']" class="user-link" [class.logged]="isLoggedIn">
                <img src="assets/images/icons/user-white.png" alt="User Account" class="user-icon" width="16" height="18">
            </a>
            <button *ngIf="isLoggedIn" (click)="toggleMenu()" class="hamburger-btn user-link" [attr.aria-expanded]="isMenuOpen" [class.logged]="isLoggedIn">
                <img src="assets/images/icons/user-white.png" alt="User Account" class="user-icon" width="16" height="18">
                <span *ngIf="userName">{{ userName }}</span>
                <img src="assets/images/icons/arrow-down.png" alt="Menu" class="arrow-icon" width="10" height="6">
            </button>

            <button *ngIf="!isLoggedIn" class="hamburger-btn" (click)="toggleMenu()" [attr.aria-expanded]="isMenuOpen">
                <img src="assets/images/icons/menu_white.png" alt="Menu" class="hamburger-icon" width="19" height="14">
            </button>
        </div>

        <button class="hamburger-btn d-md-none" (click)="toggleMenu()" [attr.aria-expanded]="isMenuOpen" *ngIf="isMobile">
            <img src="assets/images/icons/menu_white.png" alt="Menu" class="hamburger-icon" width="19" height="14">xx
        </button>
    </div>

    <!-- Mobile/Dropdown Menu -->
    <div class="mobile-menu" [class.mobile-menu--open]="isMenuOpen">
        <div class="menu-overlay" (click)="closeMenu()"></div>

        <!-- Menu Content -->
        <div class="mobile-menu-content">
            <div class="mobile-menu-header">
                <button class="close-btn" (click)="closeMenu()">
                    <span class="close-icon">×</span>
                </button>
            </div>

            <nav class="mobile-nav">
                <a routerLink="/" class="mobile-nav-link" (click)="closeMenu()">Accueil</a>
                <a routerLink="/services" class="mobile-nav-link" (click)="closeMenu()">Services</a>
                <a routerLink="/articles" class="mobile-nav-link" (click)="closeMenu()">Articles</a>
                <a routerLink="/about" class="mobile-nav-link" (click)="closeMenu()">À propos</a>
                <a routerLink="/contact" class="mobile-nav-link" (click)="closeMenu()">Contact</a>

                <ng-container *ngIf="!isLoggedIn">
                    <a href="/register" class="mobile-nav-link" (click)="closeMenu()">Inscription</a>
                </ng-container>
            </nav>

            <div class="mobile-buttons">
                @if(isLoggedIn){
                <a routerLink="/member/reservations" (click)="closeMenu()" class="mobile-reservation-btn" *ngIf="!isAdmin()">
                    <img src="assets/images/icons/shield_check.png" alt="Shield Icon" class="btn-icon">
                    <span class="btn-text">Mes Réservations</span>
                </a>
                <a routerLink="/admin/dashboard" (click)="closeMenu()" class="mobile-user-link" *ngIf="isAdmin()">
                    <img src="assets/images/icons/user-white.png" alt="User Account" class="user-icon">
                    <span>Dashboard</span>
                </a>
                <a routerLink="/member/profile" (click)="closeMenu()" class="mobile-user-link" *ngIf="!isAdmin()">
                    <img src="assets/images/icons/user-white.png" alt="User Account" class="user-icon">
                    <span>Mon Profil</span>
                </a>
                <a class="mobile-user-link" (click)="logout(); closeMenu()">
                    <img src="assets/images/icons/dashboard/logout.png" alt="User Account" class="user-icon">
                    <span>Déconnexion</span>
                </a>} @else{
                <a routerLink="/reservation" class="mobile-reservation-btn">
                    <img src="assets/images/icons/shield_check.png" alt="Shield Icon" class="btn-icon">
                    <span class="btn-text">Réservation</span>
                </a>
                <a routerLink="/login" class="mobile-user-link">
                    <img src="assets/images/icons/user-white.png" alt="User Account" class="user-icon">
                    <span *ngIf="!userName">Se connecter</span>
                </a> }
            </div>
        </div>
    </div>
</header>